"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isString = _interopRequireDefault(require("../object/isString"));

/**
 * Removes characters that are not a-z, A-Z, or 0-9 from a string
 */
var removeSpecialCharacters = function removeSpecialCharacters(string) {
  if (!(0, _isString["default"])(string)) return null;
  return string.replace(/[^a-zA-Z0-9. ]/g, '');
};

var _default = removeSpecialCharacters;
exports["default"] = _default;